import ColorPicker from '../../Core/widget/ColorPicker.js';
import SchedulerBase from '../view/SchedulerBase.js';
import VersionHelper from '../../Core/helper/VersionHelper.js';
/**
 * @module Scheduler/widget/EventColorPicker
 */

/**
 * A color picker that displays a list of available event colors which the user can select by using mouse or keyboard.
 * See Schedulers {@link Scheduler.view.mixin.TimelineEventRendering#config-eventColor eventColor config} for default
 * available colors.
 *
 * {@inlineexample Scheduler/widget/EventColorPicker.js}
 *
 * ```javascript
 * new EventColorPicker({
 *    appendTo : 'container',
 *    width    : '10em',
 *    onColorSelected(...args) {
 *        console.log(...args);
 *    }
 * });
 * ```
 *
 * @classtype colorpicker
 * @extends Core/widget/ColorPicker
 */
export default class EventColorPicker extends ColorPicker {
    static $name = 'EventColorPicker';

    static type = 'eventcolorpicker';

    static configurable = {

        colorClasses : SchedulerBase.eventColors,

        colorClassPrefix : 'b-sch-',

        /**
         * @hideconfigs colors
         */

        colors : null,

        /**
         * Provide a {@link Scheduler.model.EventModel} instance to update its
         * {@link Scheduler.model.mixin.EventModelMixin#field-eventColor} field
         * @deprecated Use {@link #config-records} instead.
         * @config {Scheduler.model.EventModel}
         */
        record : null,

        /**
         * Provide an array of {@link Scheduler.model.EventModel} instances to update their
         * {@link Scheduler.model.mixin.EventModelMixin#field-eventColor} field
         * @config {Scheduler.model.EventModel[]}
         */
        records : null
    };

    updateRecord(value) {
        if (value) {
            VersionHelper.deprecate('scheduler', '7.0.0', 'record config is deprecated in favor of records');
            this.records = [value];
        }
    }

    colorSelected({ color }) {
        if (this.records) {
            this.records.forEach(record => record.eventColor = color);
        }
    }
}

EventColorPicker.initClass();
